import { SaveOutlined, SendOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Row,
  DatePicker,
  message,
  Collapse,
  InputNumber,
  Space,
  Alert,
} from "antd";
import * as ewcms from "../../screen/EWCMS/styleMaster";
import { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  CALENDAR_DATE,
  CLAIM_STATUS,
  COL_SPAN,
  errorMsg,
  requestformItemLayout,
  REQUEST_COL_SPAN,
  SELECT_PROPS,
  STRING_DATE,
} from "../../../const/constant";
import {
  dataWrapper,
  getClaims,
  navigateBackAction,
} from "../../../redux/actions";
import { Claim } from "../../../types/RequestTypes";
import ARForm from "./ARForm";
import RequestInfoCol from "./RequestInfoCol";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import ClaimDetailsTable from "./ClaimDetailsTable";
import formatAmount from "../../../utility/formatAmount";
import ConfirmSubmitModal from "../../component/ConfirmSubmitModal";
import { RootState } from "../../../redux/reducers";
import ConfirmDelDraftModal from "../../component/ConfirmDelDraftModal";

const { RangePicker } = DatePicker;

function LumpSumPage(props) {
  const {
    device,
    currDuty,
    navigateBack,
    dataFetch,
    fetchClaims,
    claims,
    select_claim,
  } = props;
  //Button State
  const [submit, setSubmit] = useState<"Draft" | "Submit">();
  //Navigate Back State
  const [back, setBack] = useState<boolean>(false);
  // <SubmitRequestModal /> State;
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);
  const [submitValue, setSubmitValue] = useState<{ [key: string]: any }>({});
  // Delete All Draft
  const [showDelDraftModal, setShowDelDraftModal] = useState<boolean>(false);
  const [isDraftRecord, setIsDraftRecord] = useState<boolean>(false);
  const [draftClaim, setDraftClaim] = useState<Claim | null>(null);
  //Get date range
  const [period, setPeriod] = useState<[Dayjs | null, Dayjs | null] | null>();
  // Rejected Submit
  const [rejectedBatchNo, setRejectedBatchNo] = useState<string>("");
  const selectedClaim: any = useSelector(
    (state: RootState) => state.data.select_claim
  );

  const { reject_duty } = useSelector((state: RootState) => state.data);
  // @ts-ignore
  const rejectCountObj = reject_duty.find(
    (x) => x.SP_DUTY_PK === currDuty.SP_DUTY_PK
  );
  const [l_paid, setLPaid] = useState<number>(0);
  const [cNum, setCNum] = useState<number>(0);
  const [totalRejectAmt, setTotalRejectAmt] = useState<number>(0);

  const isDisabled = !period || !period[0] || !period[1] ? true : false;
  const start_date = dayjs(currDuty.START_DATE);
  const end_date = dayjs(currDuty.END_DATE);

  const rejectAlert = select_claim ? (
    <Alert
      key={select_claim.SP_SUP_CLAIM_PK}
      message={"Rejected Payment Request:"}
      description={
        <>
          <div>Batch No: {select_claim.BATCH_NO}</div>
          <div>
            Date: {dayjs(select_claim.START_DATE).format(STRING_DATE)} to{" "}
            {dayjs(select_claim.END_DATE).format(STRING_DATE)}
          </div>
          <div>Reject Reason: {select_claim.REMARKS}</div>
        </>
      }
      type="warning"
      showIcon
    />
  ) : (
    <></>
  );

  useEffect(() => {
    if (selectedClaim) {
      const { BATCH_NO: batchNo } = selectedClaim;
      setRejectedBatchNo(batchNo);
    }
  }, [selectedClaim]);

  useEffect(() => {
    if (rejectCountObj && rejectCountObj?.TOT_REJECT_AMT) {
      setTotalRejectAmt(rejectCountObj.TOT_REJECT_AMT);
    }
  }, [rejectCountObj]);

  useEffect(() => {
    if (claims && claims?.length) {
      claims.forEach((claim: Claim) => {
        if (
          claim.STATUS === CLAIM_STATUS.DRAFT ||
          claim.STATUS === CLAIM_STATUS.REJECTED
        ) {
          setIsDraftRecord(true);
          setDraftClaim(claim);
        }
      });
    }
  }, [claims]);

  useEffect(() => {
    const newLPaid =
      currDuty.LUMP_SUM_PAID -
      // (draftClaim?.TOT_CLAIM_AMT ? draftClaim?.TOT_CLAIM_AMT : 0) +
      (select_claim?.TOT_CLAIM_AMT
        ? select_claim?.TOT_CLAIM_AMT
        : draftClaim?.TOT_CLAIM_AMT
        ? draftClaim?.TOT_CLAIM_AMT
        : 0) +
      cNum;
    setLPaid(newLPaid);
  }, [currDuty, draftClaim?.TOT_CLAIM_AMT, cNum]);

  useEffect(() => {
    // if (draftClaim && draftClaim.END_DATE && draftClaim.START_DATE) {
    //   setPeriod([dayjs(draftClaim.START_DATE), dayjs(draftClaim.END_DATE)]);
    // } else if (
    //   select_claim &&
    //   select_claim.START_DATE &&
    //   select_claim.END_DATE
    // ) {
    //   setPeriod([dayjs(select_claim.START_DATE), dayjs(select_claim.END_DATE)]);
    // }

    // if (draftClaim && draftClaim?.TOT_CLAIM_AMT) {
    //   setCNum(draftClaim.TOT_CLAIM_AMT);
    // } else if (select_claim && select_claim?.TOT_CLAIM_AMT) {
    //   setCNum(select_claim.TOT_CLAIM_AMT);
    // }
    if (select_claim && select_claim.START_DATE && select_claim.END_DATE) {
      setPeriod([dayjs(select_claim.START_DATE), dayjs(select_claim.END_DATE)]);
    } else if (draftClaim && draftClaim.END_DATE && draftClaim.START_DATE) {
      setPeriod([dayjs(draftClaim.START_DATE), dayjs(draftClaim.END_DATE)]);
    }

    if (select_claim && select_claim?.TOT_CLAIM_AMT) {
      setCNum(select_claim.TOT_CLAIM_AMT);
    } else if (draftClaim && draftClaim?.TOT_CLAIM_AMT) {
      setCNum(draftClaim.TOT_CLAIM_AMT);
    }
  }, [draftClaim, select_claim]);

  useEffect(() => {
    if (back) {
      navigateBack();
    }
  }, [back, navigateBack]);

  const extraCol = (
    <>
      <Col span={COL_SPAN[device.size][0]}>Lump Sum:</Col>
      <Col span={COL_SPAN[device.size][1]}>
        {formatAmount(currDuty.LUMP_SUM)}
      </Col>
    </>
  );

  const onFinish = async (value) => {
    if (!period || !period[0] || !period[1]) {
      return;
    }
    if (value.Approver === value.Endorser) {
      errorMsg("Approver and Endorser should not be the same.");
      return;
    }
    const submit_json = {
      STAFF_NO: currDuty.STAFF_NO,
      DUTY_PK: currDuty.SP_DUTY_PK,
      CLAIM_PK: select_claim?.SP_SUP_CLAIM_PK
        ? select_claim.SP_SUP_CLAIM_PK
        : // : claims.length
        // ? claims[0].SP_SUP_CLAIM_PK
        draftClaim
        ? draftClaim.SP_SUP_CLAIM_PK
        : null,
      REQUEST_TYPE: currDuty.RATE_TYPE,
      START_DATE: period[0].format(CALENDAR_DATE),
      END_DATE: period[1].format(CALENDAR_DATE),
      CLAIMING_AMOUNT: cNum,
      Endorser: value.Endorser,
      Approver: value.Approver,
    };
    if (select_claim && select_claim?.SP_SUP_CLAIM_PK) {
      submit_json["SELECT_CLAIM"] = select_claim.SP_SUP_CLAIM_PK;
    }
    // if (currDuty.LUMP_SUM - l_paid + totalRejectAmt < 0) { // l_paid included totalRejectAmt + input
    if (currDuty.LUMP_SUM - l_paid < 0) {
      errorMsg(
        "The payment request cannot be saved/submitted as the amount requested exceeds the limit of remaining amount."
      );
      return;
    }
    if (submit === "Draft") {
      //Call SAVE DRAFT
      const response = await dataFetch(
        "ptps/makeDraftRequest",
        { value: submit_json },
        "POST"
      );
      if (response?.result === "0") {
        //Show success message
        message.success("Draft Saved Successfully");
        fetchClaims(currDuty.SP_DUTY_PK);
        //Fetch new Result
      } else {
        errorMsg(response?.error);
      }
    } else if (submit === "Submit") {
      setShowSubmitModal(true);
      setSubmitValue(submit_json);
    }
  };

  const onConfirmSubmit = async () => {
    const response = await dataFetch(
      "ptps/makeSubmitRequest",
      { value: submitValue },
      "POST"
    );
    if (response?.result === "0") {
      //Show success message
      message.success("Submission Completed");
      fetchClaims(currDuty.SP_DUTY_PK);
      setBack(true);
    } else {
      errorMsg(response?.error);
    }
  };

  const onConfirmDelDraft = async () => {
    if (!draftClaim) {
      return;
    }
    const response = await dataFetch(
      "ptps/deletePaymentRequestDraft",
      {
        data: {
          dutyPk: currDuty.SP_DUTY_PK,
          // claimPk: draftClaim.SP_SUP_CLAIM_PK,
          claimPk: select_claim?.SP_SUP_CLAIM_PK
            ? select_claim.SP_SUP_CLAIM_PK
            : draftClaim.SP_SUP_CLAIM_PK,
          staffNo: currDuty.STAFF_NO,
          requestType: "L",
        },
      },
      "POST"
    );
    if (response?.result === "0") {
      //Show success message
      const successMsg = `The ${
        rejectedBatchNo ? "rejected" : ""
      } payment request has been deleted.`;
      message.success(successMsg);
      fetchClaims(currDuty.SP_DUTY_PK);
      setShowDelDraftModal(false);
      setIsDraftRecord(false);
      setDraftClaim(null);
      setBack(true);
    } else {
      setShowDelDraftModal(false);
      errorMsg(response?.error);
    }
  };

  const disabledDate = (current: Dayjs) => {
    if (
      current.isBefore(start_date, "date") ||
      current.isAfter(end_date, "date")
    )
      return true;
    return false;
  };

  return (
    <div style={{ padding: "1rem 0" }}>
      <RequestInfoCol extraCol={extraCol} l_paid={l_paid} />
      <Divider />
      {select_claim && (
        <Space
          direction="vertical"
          style={{ width: "100%", marginBottom: "24px" }}
        >
          {rejectAlert}
        </Space>
      )}
      <Collapse defaultActiveKey={["1"]}>
        <Collapse.Panel header={"Payment Request"} key="1">
          <Form
            onFinish={onFinish}
            layout={device.size !== "mobile" ? "horizontal" : "vertical"}
            className="calendar-form"
            {...requestformItemLayout[device.size]}
          >
            <Row gutter={[0, 16]}>
              <ARForm select_claim={select_claim} />
              <Col span={REQUEST_COL_SPAN[device.size][0]}>Remaining:</Col>{" "}
              <Col span={REQUEST_COL_SPAN[device.size][1]}>
                <b>{formatAmount(Math.max(currDuty.LUMP_SUM - l_paid, 0))}</b>
              </Col>
              <Col span={24} style={{ fontStyle: "italic" }}>
                Please enter requesting period and amount:
              </Col>
              <Col {...SELECT_PROPS[device.size]}>
                <Form.Item
                  label={"Requesting Period: "}
                  rules={[
                    {
                      required: true,
                      message: "Please select the Requesting Period.",
                    },
                  ]}
                >
                  <RangePicker
                    format={STRING_DATE}
                    disabledDate={disabledDate}
                    placement={
                      device.size === "mobile" ? "topLeft" : "bottomLeft"
                    }
                    onChange={(value) => setPeriod(value)}
                    value={period}
                  />
                </Form.Item>
              </Col>
              <Col {...SELECT_PROPS[device.size]}>
                <Form.Item
                  label={"Requesting Amount: "}
                  rules={[
                    {
                      required: true,
                      message: "Please enter the Requesting Amount",
                    },
                    {
                      validator: (rule, value, callback) => {
                        value <= 0
                          ? callback("Requesting Amount must be greater than 0")
                          : callback();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    value={cNum}
                    min={0}
                    onChange={(value: number | null) =>
                      setCNum(value ? value : 0)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              gutter={[16, 16]}
              style={{ marginTop: "1rem", marginBottom: "1rem" }}
            >
              {select_claim ? (
                <></>
              ) : (
                <Col>
                  <Button
                    className="align-center-btn"
                    onClick={() => {
                      setSubmit("Draft");
                    }}
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    disabled={isDisabled}
                  >
                    Save
                  </Button>
                </Col>
              )}
              <Col>
                <Button
                  className="align-center-btn"
                  onClick={() => {
                    setSubmit("Submit");
                  }}
                  type="primary"
                  htmlType="submit"
                  icon={<SendOutlined />}
                  disabled={isDisabled}
                >
                  Submit
                </Button>
              </Col>
              {isDraftRecord ? (
                <Col>
                  <Button
                    className={ewcms.defaultBtnStyle + " cust-button-height"}
                    onClick={() => {
                      setShowDelDraftModal(true);
                    }}
                    htmlType="button"
                  >
                    Delete
                  </Button>
                </Col>
              ) : (
                <></>
              )}
              <Col>
                <Button
                  onClick={() => {
                    setBack(true);
                  }}
                  htmlType="button"
                >
                  Cancel
                </Button>
              </Col>
            </Row>

            <ConfirmSubmitModal
              showModal={showSubmitModal}
              setshowModal={setShowSubmitModal}
              title={"Are you sure to submit?"}
              onConfirmSubmit={onConfirmSubmit}
            />

            <ConfirmDelDraftModal
              setShowDelDraftModal={setShowDelDraftModal}
              showDelDraftModal={showDelDraftModal}
              onConfirmDelDraft={onConfirmDelDraft}
              isRejectedMode={rejectedBatchNo ? true : false}
            />
          </Form>
        </Collapse.Panel>
        <Collapse.Panel header={"Payment Request History"} key="2">
          <ClaimDetailsTable claims={claims} hideCol={["TIME"]} />
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currDuty: state.data.currDuty,
    device: state.session.device,
    claims: state.data.claims,
    select_claim: state.data.select_claim,
  };
};

const mapDispatchToProps = (dispatch) => ({
  navigateBack: () => {
    dispatch(navigateBackAction());
  },
  dataFetch: (apiPath, data, method) => {
    return dispatch(dataWrapper(apiPath, data, method));
  },
  fetchClaims: (duty_pk) => {
    return dispatch(getClaims(duty_pk));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LumpSumPage);
